import React from 'react';

const PageManagmentPlaceholder = () => {
    return <div className='tb--placeholder page-managment tb--w_100'>
        <div className='page-managment-banner tb--show-animation'></div>
        <div className='small-banner-placeholder tb--flex tb--show-animation'>
            <div></div>
            <div></div>
            <div></div>
        </div>

        <div className='page-managment-lines tb--show-animation'>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
}


export default PageManagmentPlaceholder;